import {defineField, defineType} from 'sanity'

import AccessoriesSkus from '../../components/AccessoriesSkus'

export default defineType({
  name: 'centerCapsConfiguration',
  title: 'Center Caps Configuration',
  type: 'document',
  fields: [
    defineField({
      name: 'name',
      title: 'Configuration Name',
      type: 'string',
      validation: (rule) => rule.required(),
    }),
    defineField({
      title: 'Message',
      name: 'message',
      type: 'text',
      rows: 2,
    }),
    defineField({
      title: 'Message Modal',
      name: 'modal',
      type: 'reference',
      to: [{type: 'modal'}],
    }),
    defineField({
      name: 'skus',
      title: 'Product SKUs',
      description: 'Comma separated skus can be used for searching',
      type: 'string',
      components: {
        input: AccessoriesSkus,
      },
    }),
  ],
  preview: {
    select: {
      title: 'name',
    },
    prepare({title = 'New Configuration'}) {
      return {
        title,
        subtitle: 'Center Caps Configuration',
      }
    },
  },
})
